import Config from 'config';
let config;
import find from 'lodash/find';
import uniqBy from 'lodash/uniqBy';

export function getStatusMapping(statusCode, mappings) {
  config = new Config().getConfig();
  mappings = mappings || config.seatTypes.seatMappings;
  return (
    find(mappings, mapping => {
      return mapping.statusCode == statusCode;
    }) || config.seatTypes.defaultMapping
  );
}

export function getAvailableSeatTypes() {
  config = new Config().getConfig();
  return uniqBy(
    config.seatTypes.defaultTypes.concat(config.seatTypes.customTypes)
  );
}

export function getSeatType(statusCode) {
  let availableTypes = getAvailableSeatTypes();
  let mapping = getStatusMapping(statusCode);
  return find(availableTypes, type => type.id === mapping.draw);
}

export default {
  getStatusMapping,
  getAvailableSeatTypes,
  getSeatType
};



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/seatTypes.js